import React from 'react';
import {ALIS, CURRENCIES, ITEMS, SATIS} from "./constants";
import {calculateCurrency, calculateItem} from "./commons";

const Row = ({title, alis, satis}) => {

    if (title === "Has Altın") {
        title = "Has Altın (24 Ayar)"
    } else if (title === "Bilezik") {
        title = "Bilezik (22 Ayar)"
    }

    return (
        <tr>
            <td>{title}</td>
            <td>{alis || 'Yükleniyor...'}</td>
            <td>{satis || 'Yükleniyor...'}</td>
        </tr>
    )
}


class PricesScreen extends React.Component {

    state = {
        prices: null,
        settings: null,
    };

    componentWillMount() {
        this.fetchData();
        setInterval(this.fetchData, 60 * 1000)
    }

    fetchData = () => {
        fetch('/api/')
            .then(res => res.json())
            .then(res => {
                this.setState(res)
            })
            .catch(err => console.log(err));
    }

    hasAltinRow = () => {
        const {settings, prices} = this.state;
        let alis = parseFloat(prices.altin.alis) + parseFloat(settings.has_altin.alis_ekleme)
        let satis = parseFloat(prices.altin.satis) + parseFloat(settings.has_altin.satis_ekleme)
        alis = alis.toFixed(2)
        satis = satis.toFixed(2)
        return <Row title="Has Altın" alis={alis} satis={satis}/>
    };

    currencyRow = (currency) => {
        const {settings, prices} = this.state;
        let currencyPrice = prices[currency.name];
        let alis = calculateCurrency(currencyPrice, settings[currency.name], ALIS)
        let satis = calculateCurrency(currencyPrice, settings[currency.name], SATIS)

        return <Row key={currency.name} title={currency.title} alis={alis} satis={satis}/>
    };

    itemRow = (item) => {
        const {settings, prices} = this.state;
        let alis = calculateItem(prices.altin, settings, ALIS, item.name)
        let satis = calculateItem(prices.altin, settings, SATIS, item.name)

        return <Row key={item.name} title={item.title} alis={alis} satis={satis}/>
    };

    requestFullScreen = (element) => {
        // Supports most browsers and their versions.
        let requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;

        if (requestMethod) { // Native full screen.
            requestMethod.call(element);
        } else if (typeof window.ActiveXObject !== "undefined") { // Older IE.
            let wscript = new window.ActiveXObject("WScript.Shell");
            if (wscript !== null) {
                wscript.SendKeys("{F11}");
            }
        }
    };

    renderTableHeader = () => {
        return (
            <tr style={{fontWeight: 'bold'}}>
                <td style={{cursor: 'pointer'}} onClick={() => this.requestFullScreen(document.body)}>Tavsiye Edilen Fiyatlar</td>
                <td>ALIŞ</td>
                <td>SATIŞ</td>
            </tr>
        )
    };

    render() {

        if (!this.state.prices || !this.state.settings) {
            return (
                <div className="loading_message">
                    <div style={{textAlign: 'center'}}>
                        <h1>Yükleniyor.</h1>
                        <br/>
                        <h3>İşlem uzun sürüyor ise sayfayı yenileyin.</h3>
                    </div>
                </div>
            )
        }

        return (
            <div id="fullscreen" className="fullscreen">
                <table className="fs_table">
                    {this.renderTableHeader()}
                    {this.hasAltinRow()}
                    {ITEMS.map(item => this.itemRow(item))}
                    {CURRENCIES.map(currency => this.currencyRow(currency))}
                </table>
            </div>
        );
    }
}

export default PricesScreen


// WEBPACK FOOTER //
// ./src/PricesScreen.js